import { s } from '@w/schema'

const GOOGLE_CLIENT_ID =
  '1008288612985-1s66jrs99mt4uh01ppd20ch52keu9h67.apps.googleusercontent.com'

const feEnvVarsSchema = s.object({
  BACKEND_URL: s.string(),
  OTA_URL: s.string().optional(),
  OTA_PUBLIC_KEY: s.string().optional(),
  GOOGLE_CLIENT_ID: s.string(),
  GOOGLE_IOS_CLIENT_ID: s.string().optional(),
  GOOGLE_ANDROID_CLIENT_ID: s.string().optional(),
  MEDIA_PUBLIC_BASE_URL: s.string(),
})

function getBackendUrl(): string {
  return import.meta.env.VITE_BACKEND_URL?.replace(/\/$/, '') ?? '/api'
}

export const feEnvVars = feEnvVarsSchema.parse({
  BACKEND_URL: getBackendUrl(),
  OTA_URL: import.meta.env.VITE_OTA_URL,
  OTA_PUBLIC_KEY: import.meta.env.VITE_OTA_PUBLIC_KEY,
  GOOGLE_CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID ?? GOOGLE_CLIENT_ID,
  GOOGLE_IOS_CLIENT_ID: import.meta.env.VITE_GOOGLE_IOS_CLIENT_ID,
  GOOGLE_ANDROID_CLIENT_ID: import.meta.env.VITE_GOOGLE_ANDROID_CLIENT_ID,
  MEDIA_PUBLIC_BASE_URL: import.meta.env.VITE_MEDIA_PUBLIC_BASE_URL ?? '',
})
